import React from "react";

// 🖼️ Import all required images
import icon06 from "./../assets/AyurvedaAssets/images/icon-06.png";
import blog01_635x420 from "./../assets/AyurvedaAssets/images/blog/blog-01-635x420.jpg";
import blog03_635x420 from "./../assets/AyurvedaAssets/images/blog/blog-03-635x420.jpg";
import blog02_1300x390 from "./../assets/AyurvedaAssets/images/blog/blog-02-1300x390.jpg";

export default function DetailedBlog() {
  return (
    <>
      {/* Page Title */}
      <div className="prt-page-title-row style4">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-9 col-lg-12 m-auto">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h3 className="post-detail">Therapy</h3>
                    <h2 className="title">
                      Get the best HTML templates for medical service
                    </h2>
                  </div>
                  <div className="page-title-desc">
                    <div className="user-id">
                      <span className="user-image">
                        <img src={icon06} alt="author" />
                      </span>
                      <span className="author-wrapper">
                        <span className="auther-name">John Doe</span>
                        <span className="auther-name">September 7, 2023</span>
                        <span className="auther-name">0 Comments</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Site Main */}
      <div className="site-main">
        {/* Blog Single Section */}
        <section className="prt-row blog-details-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-blog-single-content">
                  <div className="entry-content">
                    <div>
                      <p>
                        Dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod{" "}
                        <span className="text-base-dark text-decoration-underline">
                          <em> tempor incididunt ut labore </em>
                        </span>{" "}
                        et dolore magna aliqua. Quis ipsum suspendisse ultrices
                        gravida. Risus commodo viverra maecenas accumsan lacus
                        vel facilisis sit amet, consectetur adipisicing elit,
                        sed do eiusmod dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. Quis ipsum suspendisse ultrices
                        gravida. Risus commodo viverra maecenas accumsan lacus
                        vel facilisis.
                      </p>
                    </div>

                    {/* Two Images Row */}
                    <div className="row pb-30 pt-10">
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="prt-blog-single-image">
                          <img
                            width="635"
                            height="420"
                            className="img-fluid border-rad_10"
                            src={blog01_635x420}
                            alt="blog"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="prt-blog-single-image res-575-mt-30">
                          <img
                            width="635"
                            height="420"
                            className="img-fluid border-rad_10"
                            src={blog03_635x420}
                            alt="blog"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Full-width Image */}
                    <div className="row pb-30">
                      <div className="col-lg-12">
                        <img
                          width="1300"
                          height="390"
                          className="img-fluid border-rad_10"
                          src={blog02_1300x390}
                          alt="blog"
                        />
                      </div>
                    </div>

                    {/* Blog Description */}
                    <div className="blog-single-title">
                      <h3>What you will do</h3>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Quis ipsum suspendisse ultrices gravida.
                        Risus commodo viverra maecenas accumsan lacus vel
                        facilisis lorem ipsum dolor sit amet, consectetur
                        adipisicing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam,
                        quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor
                        in reprehenderit in voluptate velit esse cillum dolore
                        eu fugiat nulla pariatur.
                      </p>
                    </div>

                    {/* Social Tags & Icons */}
                    <div className="prt-box-desc-text mt-45 res-991-mt-30">
                      <div className="social-media-block d-block">
                        <div className="d-md-flex justify-content-between align-items-center">
                          <div className="prt-social-share-wrapper">
                            <a href="#">Care</a>
                            <a href="#">Therapy</a>
                          </div>
                          <div className="res-767-mt-20">
                            <ul className="social-icons">
                              <li>
                                <a
                                  href="#"
                                  rel="noopener"
                                  aria-label="facebook"
                                >
                                  <i className="icon-facebook"></i>
                                </a>
                              </li>
                              <li>
                                <a href="#" rel="noopener" aria-label="twitter">
                                  <i className="icon-twitter"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#"
                                  rel="noopener"
                                  aria-label="linkedin"
                                >
                                  <i className="icon-linkedin"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#"
                                  rel="noopener"
                                  aria-label="instagram"
                                >
                                  <i className="icon-instagram"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Comment Form */}
                    <div className="prt-blog-classic-box-comment_1 mt-40 res-991-mt-30">
                      <h3>Leave a reply</h3>
                      <p>Your email address will not be published.</p>
                      <div id="comments_1" className="comments-area_1">
                        <div className="comment-respond">
                          <form
                            action="#"
                            method="post"
                            id="commentform"
                            className="comment-form_1"
                          >
                            <p className="comment-form-comment">
                              <textarea
                                id="comment"
                                placeholder="comment"
                                name="comment"
                                cols="45"
                                rows="4"
                                aria-required="true"
                              ></textarea>
                            </p>
                            <p className="comment-form-author">
                              <input
                                id="author"
                                placeholder="name (required)"
                                name="author"
                                type="text"
                                size="30"
                                aria-required="true"
                              />
                            </p>
                            <p className="comment-form-email">
                              <input
                                id="email"
                                placeholder="email (required)"
                                name="email"
                                type="email"
                                size="30"
                                aria-required="true"
                              />
                            </p>
                            <p className="comment-form-web">
                              <input
                                id="web"
                                placeholder="Website"
                                name="website"
                                type="text"
                                size="30"
                              />
                            </p>
                            <p className="form-submit cookies mb-20 mt-110 res-767-mt-0">
                              <span>
                                <input
                                  type="checkbox"
                                  name="cookies-consent"
                                  id="cookies-consent2"
                                />
                                <label htmlFor="cookies-consent2"></label>
                                Save my name, email, and website in this browser
                                for the next time I comment.
                              </span>
                            </p>
                            <p className="form-submit mt-25 mb-0">
                              <button
                                className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                                type="submit"
                              >
                                Post Comment
                              </button>
                            </p>
                          </form>
                        </div>
                      </div>
                    </div>
                    {/* Comment Form End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
